import { render, staticRenderFns } from "./ClientView.vue?vue&type=template&id=d6927a64&scoped=true&"
import script from "./ClientView.vue?vue&type=script&lang=js&"
export * from "./ClientView.vue?vue&type=script&lang=js&"
import style0 from "./ClientView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ClientView.vue?vue&type=style&index=1&id=d6927a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6927a64",
  null
  
)

export default component.exports